import { ModuleBase } from "@/modules/base";
import { Component, Vue, Mixins } from 'vue-property-decorator';
import AnalysisMenu from "./AnalysisMenu.vue";
import { fileDragAndDrop } from '../CatalogOverplotModule/file_drag_and_drop';
import { FitsImage } from './FitsImage';
import PatchLayer from "./PatchLayer.vue";
import ManagerWindow from './ManagerWindow.vue'
import ToneWindow from './ToneWindow.vue'
import { store } from '@/store';

@Component
export class FitsImageModule extends Mixins(ModuleBase) {
  showManager = false

  frameStore() {
    @Component
    class FrameStore extends Vue {
      fitsImages: FitsImage[] = []
    }
    return new FrameStore()
  }

  get outlet() {
    return {
      window: [ManagerWindow, ToneWindow],
      patchLayer: PatchLayer,
      analysisMenu: AnalysisMenu,
    }
  }

  async loadImage(file: File) {
    await store.asyncProgress(`Loading Fits Image: ${file.name}`, async () => {
      const fitsImage = await FitsImage.fromFile(file)
      store.currentFrame.modules.fitsImage.fitsImages.push(fitsImage)
      this.showManager = true
    })
  }

  private fileDragAndDropUnset!: () => void
  created() {
    this.fileDragAndDropUnset = fileDragAndDrop.set(document.body, (file) => {
      if (file.name.match(/.fits(?:\.gz)?$/i)) {
        this.loadImage(file)
      }
    })
  }

  beforeDestroy() {
    this.fileDragAndDropUnset()
  }
}
